// src/components/gestionEvento/Ajustes/Competidores/ListsTab.js
import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import RelaysTable from '../../RelayTable';
import { useParams } from 'react-router-dom';
import { useCompetencia } from '../../../../context/CompetenciaContext';

// ✅ importa la nueva tabla con sidebar
import MemberTable from './Inscripciones/MemberTable';

const ListsTab = () => {
  const { competitionId, slug } = useParams();
  const { competencias, fetchInscripcionesCached, listenInscripcionesByCounter } = useCompetencia();

  const comp =
    competencias.find((c) => c.id === competitionId) ||
    competencias.find((c) => c.slug === slug);

  useEffect(() => {
    if (!comp?.id) return;
    let cleanup = () => {};
    (async () => {
      try {
        await fetchInscripcionesCached(comp.id);
        cleanup = listenInscripcionesByCounter(comp.id);
      } catch (e) {
        console.warn('No se pudieron cargar/escuchar inscripciones:', e);
      }
    })();
    return () => cleanup();
  }, [comp?.id, fetchInscripcionesCached, listenInscripcionesByCounter]);

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Lista de Inscritos
      </Typography>

      {/* ✅ Reemplaza la tabla anterior por la nueva con sidebar */}
      <Box sx={{ mt: 1.5, mb: 3 }}>
        <MemberTable />
      </Box>

      <Typography variant="h6" gutterBottom>
        Lista de Relevos
      </Typography>
      <Box sx={{ mt: 1.5, mb: 3 }}>
        <RelaysTable />
      </Box>
    </Box>
  );
};

export default ListsTab;
